export default __webpack_public_path__ + "static/wyoming-ad2a54df53fce08d413b46fe45652540.png";